<div class="panel-header">
  <!-- Button style trigger -->
  @if (triggerConfig().style === 'button') {
    <button
      #triggerBtn
      accredible-button-flat
      [id]="triggerBtnId"
      [class.full-width]="triggerConfig().width === 'full'"
      [attr.data-cy]="dataCy()"
      [attr.aria-expanded]="!disabled() ? expanded() : null"
      [attr.aria-controls]="!disabled() ? panelContentId : null"
      [attr.aria-label]="
        expanded() ? triggerConfig().collapseAriaLabel : triggerConfig().expandAriaLabel
      "
      [icon]="'chevron-down'"
      [iconSize]="'10px'"
      [rotateIcon]="expanded()"
      (click)="onTrigger()">
      {{ expanded() ? triggerConfig().collapseText : triggerConfig().expandText }}
    </button>
  } @else {
    @if (triggerConfig().style === 'custom') {
      <div class="custom-trigger">
        <ng-content select="[expansionPanelHeader]" />

        <div
          class="custom-trigger-btn"
          role="button"
          tabindex="0"
          [id]="triggerBtnId"
          [class.full-width]="triggerConfig().width === 'full'"
          [attr.data-cy]="dataCy()"
          [attr.aria-expanded]="!disabled() ? expanded() : null"
          [attr.aria-controls]="!disabled() ? panelContentId : null"
          [attr.aria-label]="
            expanded() ? triggerConfig().collapseAriaLabel : triggerConfig().expandAriaLabel
          "
          (click)="onTrigger()"
          (keyup.enter)="onTrigger()">
          <accredible-icon [icon]="expanded() ? 'chevron-up' : 'chevron-down'" />
        </div>
        <div class="actions-wrapper">
          <ng-content select="[expansionPanelHeaderActions]" />
        </div>
      </div>
    } @else {
      <!-- Link style trigger -->
      <button
        #triggerBtn
        accredible-link
        [id]="triggerBtnId"
        [class.full-width]="triggerConfig().width === 'full'"
        [attr.data-cy]="dataCy()"
        [attr.aria-expanded]="!disabled() ? expanded() : null"
        [attr.aria-controls]="!disabled() ? panelContentId : null"
        [attr.aria-label]="
          expanded() ? triggerConfig().collapseAriaLabel : triggerConfig().expandAriaLabel
        "
        [icon]="'chevron-down'"
        [rotateIcon]="expanded()"
        (click)="onTrigger()">
        {{ expanded() ? triggerConfig().collapseText : triggerConfig().expandText }}
      </button>
    }
  }

  @if (!disabled()) {
    <div
      #expandableRegionEl
      class="panel-content"
      role="region"
      [id]="panelContentId"
      [attr.aria-label]="expandableRegionAriaLabel()"
      (@expansionPanelAnimation.done)="onExpand()"
      [@expansionPanelAnimation]="
        expanded() ? expansionPanelState.expanded : expansionPanelState.collapsed
      ">
      <ng-content />
    </div>
  }
</div>
